import LoginRequest from '../ws/LoginRequest';
import UserRequest from '../ws/UserRequest';
import { PsRoutes } from '../../shared/routing/Routes';
import { push } from 'react-router-redux';
import RememberPasswordRequest from '../ws/RememberPasswordRequest';
import { I18nUtils } from '../../../i18n/I18nUtils';
import Alert from 'react-s-alert';
import ResetPasswordRequest from '../ws/ResetPasswordRequest';
import { LoginManagerInstance } from '../LoginManager';

export const AUTH_LOGIN_LOADING = 'auth-login-loading';
export const AUTH_LOGIN_SUCCESS = 'auth-login-success';
export const AUTH_LOGIN_ERROR = 'auth-login-error';
export const AUTH_LOGIN_USER = 'auth-login-user';
export const AUTH_LOGIN_UPDATE = 'auth-login-update';
export const AUTH_CHANGE_EMAIL = 'auth-change-email';
export const AUTH_CHANGE_PASSWORD = 'auth-change-password';
export const AUTH_CHANGE_REMEMBER = 'auth-change-remember';

export const AUTH_REMEMBER_PASSWORD_LOADING = 'auth-remember-password-loading';
export const AUTH_REMEMBER_PASSWORD_ERROR = 'auth-remember-password-error';

export const AUTH_RESET_PASSWORD_LOADING = 'auth-reset-password-loading';
export const AUTH_RESET_PASSWORD_ERROR = 'auth-reset-password-error';
export const AUTH_CHANGE_RESET_PASSWORD = 'auth-change-reset-password';
export const AUTH_CHANGE_RESET_PASSWORD_REPEAT = 'auth-change-reset-password-repeat';

export const changeEmail = (email) => ( {
    type: AUTH_CHANGE_EMAIL,
    payload: email,
} );

export const changePassword = (password) => ( {
    type: AUTH_CHANGE_PASSWORD,
    payload: password,
} );

export const changeRemember = (remember) => ( {
    type: AUTH_CHANGE_REMEMBER,
    payload: remember,
} );

export const login = (email, password, remember = false) => (dispatch) => {

    new LoginRequest(email, password, remember)
        .onPreExecution(() => {
            dispatch({ type: AUTH_LOGIN_LOADING, payload: true });
        })
        .onSuccess(response => {
            const token = response.data;
            dispatch({
                type: AUTH_LOGIN_SUCCESS,
                payload: token,
            });
            LoginManagerInstance.login(token, '/');
            dispatch(push(PsRoutes.HOME));
            window.location.reload();
        })
        .onFail(error => {
            dispatch({
                type: AUTH_LOGIN_ERROR,
                payload: error,
            });
        })
        .onPostExecution(() => {
            dispatch({ type: AUTH_LOGIN_LOADING, payload: false });
        })
        .execute();
};

export const getUser = () => (dispatch) => {

    new UserRequest()
        .onSuccess(response => {
            dispatch({
                type: AUTH_LOGIN_USER,
                payload: response.data,
            });
        })
        .execute();
};

export const goToRouteLogin = () => (dispatch) => {
    dispatch(push(PsRoutes.HOME));
};

export const rememberPassword = (email) => (dispatch) => {

    new RememberPasswordRequest(email)
        .onPreExecution(() => {
            dispatch({ type: AUTH_REMEMBER_PASSWORD_LOADING, payload: true });
        })
        .onSuccess(response => {
            Alert.success(I18nUtils.tr('TR_SE_HA_ENVIADO_UN_EMAIL_CON_LAS_INSTRUCCIONES'));
            dispatch(push(PsRoutes.HOME));
        })
        .onFail(error => {
            dispatch({
                type: AUTH_REMEMBER_PASSWORD_ERROR,
                payload: error,
            });
        })
        .onPostExecution(() => {
            dispatch({ type: AUTH_REMEMBER_PASSWORD_LOADING, payload: false });
        })
        .execute();
};

export const changeResetPassword = (password) => ( {
    type: AUTH_CHANGE_RESET_PASSWORD,
    payload: password,
} );

export const changeResetPasswordRepeat = (password) => ( {
    type: AUTH_CHANGE_RESET_PASSWORD_REPEAT,
    payload: password,
} );

export const resetPassword = (password, passwordRepeat, token) => (dispatch) => {

    if ( password === passwordRepeat ) {
        new ResetPasswordRequest(password, token)
            .onPreExecution(() => {
                dispatch({ type: AUTH_RESET_PASSWORD_LOADING, payload: true });
            })
            .onSuccess(response => {
                Alert.success(I18nUtils.tr('TR_SE_HA_CAMBIADO_LA_CONTRASENA_CON_EXITO'));
                dispatch(push(PsRoutes.HOME));
            })
            .onFail(error => {
                dispatch({
                    type: AUTH_RESET_PASSWORD_ERROR,
                    payload: error,
                });
            })
            .onPostExecution(() => {
                dispatch({ type: AUTH_RESET_PASSWORD_LOADING, payload: false });
            })
            .execute();
    } else {
        dispatch({
            type: AUTH_RESET_PASSWORD_ERROR,
            payload: I18nUtils.tr('TR_LAS_CONTRASENAS_INTRODUCIDAS_SON_DIFERENTES'),
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/login/actions/authActions.js